import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiGetQuizzesResults = async (data, type) => {
    let form = new FormData();
    form.append("mcid", data.mcid)
    form.append("key", data.key);
    form.append("instance", data.instance);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSASPQuizzesTableById"
            },
            data: form
        });
        
        return response.data[0];
    } catch (error) {
        throw error;
    }
}

export const apiGetQuizzesListResults = async (data, type) => {
    let form = new FormData();
    form.append("mcid", data.mcid)
    form.append("key", data.key);
    form.append("deckid", data.deckid);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSASPQuizzesTableById"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiGetQuizzesListAllResults = async (data, type) => {
    let form = new FormData();
    form.append("mcid", data.mcid)
    form.append("key", data.key);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSASPQuizzesTable"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}